import { withPrefix } from 'gatsby'

const config = {
	title: "NOLTE Architektur",
	description: "Architekturbüro Renate Nolte",
	logo: withPrefix("icon.png"),
	url: "nolte-architektur.de",
}

export default config;